import OpenModuleAction from './OpenModuleAction';
import { hasEditionRoot, isPlanned } from 'actions/actionUtils';

export default OpenModuleAction.extend({
  isApplicable: function () {
    return !hasEditionRoot(this.module) && isPlanned(this.module);
  }
});
